import { render, staticRenderFns } from "./LoanDeclineModal.vue?vue&type=template&id=4d1460c2&scoped=true&"
import script from "./LoanDeclineModal.vue?vue&type=script&lang=js&"
export * from "./LoanDeclineModal.vue?vue&type=script&lang=js&"
import style0 from "./LoanDeclineModal.vue?vue&type=style&index=0&id=4d1460c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1460c2",
  null
  
)

export default component.exports